module.exports = __webpack_public_path__ + "static/media/BB.71da99ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BB.svg
// module id = 2107
// module chunks = 7